const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'fields-all-school-offer',
		text: `Er det rigtigt, at alle gymnasier tilbyder alle eksisterende studieretninger?`,
		hintText: `Tænk på forskelle mellem små og store gymnasier.`,
		popupText: `Hvert gymnasium vælger selv, hvilke studieretninger de udbyder – derfor er der forskelle rundt i landet.`,
		image: 'group-with-hats',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Nej', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ja'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'fields-facts',
		text: `Hvad tror I er rigtigt om studieretningerne?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `Studieretningen er central, fordi den bestemmer niveauer i fagene og dermed, hvilke videregående uddannelser man senere kan søge ind på.`,
		image: 'stx-poster',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Du kan vælge studieretning hvert år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Valget af studieretning påvirker hvilke fag og niveauer du får', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Valg af studieretning kan have betydning for videregående uddannelser', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Alle studieretninger giver adgang til alle uddannelser'
			}),
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		taskId: 'fields-sort-required',
		title: 'Opgave 1A',
		text: `På STX vælger du selv nogle fag – men de fleste er obligatoriske. Hvilke af disse tror I, alle skal have?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `De obligatoriske fag er valgt, så alle får en bred grundpakke.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'required', 
				title: `Obligatorisk fag`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notRequired', 
				title: `Ikke obligatorisk fag`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Historie`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Engelsk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Matematik`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Fysik`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Idræt`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Oldtidskundskab`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, text: `Religion`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9, text: `Samfundsfag`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 10, text: `Tysk`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 11, text: `Filosofi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 12, text: `Musik`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 13, text: `Kemi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 14, text: `Biologi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 15, text: `Fransk`, categoryIds: ['notRequired']
			}),
		]
	}),
Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'fields-sort-levels',
		title: 'Opgave 1B',
		lockedById: 'fields-sort-required',
		text: `På STX er fagene på tre niveauer: A, B og C – og A er det højeste. Hvilket niveau har man som udgangspunkt de her fag på?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `A-, B- og C-niveau er et system, der sikrer du kan blive dygtigere, hvert niveau tager et skoleår at gennemføre.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'a', 
				title: `A-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'b', 
				title: `B-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'c', 
				title: `C-niveau`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Historie`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Engelsk`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Matematik`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Fysik`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Idræt`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Oldtidskundskab`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, text: `Religion`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9, text: `Samfundsfag`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 10, text: `Kemi`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 14, text: `Biologi`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 15, text: `Informatik`, categoryIds: ['c']
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 2',
		taskId: 'fields-rules',
		text: `Hvordan fungerer fagene på STX?
			<br /><br />Kan I spotte, hvilke regler der gælder for A-niveaufag - og hvad man selv kan vælge? Vælg de rigtige svar!`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `Reglen om mindst fire A-niveaufag betyder, at alle elever kommer igennem et højt fagligt niveau.`,
		image: 'classroom-students-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Som elev på STX skal du have mindst fire fag på A-niveau', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Som elev på STX skal du have mindst tre fag på A-niveau'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Man kan godt vælge at få endnu flere A-niveau fag hvis man selv ønsker det', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Man kan ikke vælge at få flere A-niveau fag hvis man selv ønsker det'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Man kan vælge de samme valgfag på alle STX gymnasier i Danmark'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		subtype: 'images',
		title: 'Opgave 1A',
		taskId: 'fields-mc-fields-of-study',
		text: `At vælge studieretning er noget, mange ser frem til, når de starter på gymnasiet – og der er masser at vælge imellem. Find de 4 billeder, der passer til STX-studieretninger.`,
		hintText: `Det kan googles på “STX studieretninger”`,
		layout: 'stx-fields-of-study',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'science', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'society', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'languages', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'art', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'finance',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'media',
			}),
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'fields-sort-emojis',
		lockedById: 'fields-mc-fields-of-study',
		subtype: 'images',
		title: 'Opgave 1B',
		text: `Gæt studieretningen!
			<br />Vi har samlet nogle emojis, der viser fagene og temaerne i en studieretning. Kan I finde ud af, hvilken det er? Tryk på det rigtige svar og se, om I har styr på studieretningerne!`,
		hintText: `Prøv at matche ikonerne med et fagområde.`,
		layout: 'fields-emojis',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'science', title: `Naturvidenskab`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'social', title: `Samfundsvidenskab`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'languages', title: `Sprog`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'art', title: `Kreative`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'microscope', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'dna', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'tube', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'telescope', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'magnet', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'scales', type: 'image', type: 'image', categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'court-house', type: 'image', categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'graph', type: 'image', categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'speaking', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'earth', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'flag', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'paint', type: 'image', categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'masks', type: 'image', categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'music', type: 'image', categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'film', type: 'image', categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'microphone', type: 'image', categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'camera', type: 'image', categoryIds: ['art']})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		taskId: 'fields-order-study-field',
		title: 'Opgave 2',
		text: `Vi leger, at I er elever, der skal vælge en studieretning. Hvad tror I, at man oplever undervejs? Sæt trinnene i den rækkefølge, de typisk sker.`,
		hintText: `Overvej, hvad der logisk sker først, når man starter.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Introforløb på gymnasiet`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Overvej interesser og fremtid`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælg og søg en studieretning`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Start på fagene`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Arbejd med fag og eksamen`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Gå til eksamen i de valgte fag`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'fields-when-choose-field',
		text: `Hvornår vælger man sin studieretning på STX?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `Studieretning vælges først efter grundforløbet, fordi eleverne skal prøve fagene af, inden de træffer et endeligt valg.`,
		image: 'stx-fields-of-study',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Første skoledag'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Før man starter',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'I slutningen af grundforløbet', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Når man afslutter 1. g'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Det kan man selv bestemme'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Når man afslutter 2. g'
			}),
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'fields-spot-errors-sfx-room',
		layout: 'fields-sfx-classroom',
		text: `Velkommen til et af gymnasiets store lokaler! Men nogle af eleverne passer vist ikke helt ind på et typisk STX-gymnasium. Find fejlene – og tryk OK, når I tror, I har dem alle.`,
		hintText: `Nogle af personerne laver noget, man aldrig gør på STX.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sawing'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'money'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tool'})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		taskId: 'fields-order-science-day',
		title: 'Opgave 2',
		text: `Hvordan tror I, en helt dag kan se ud for en elev på naturvidenskabs-studieretningen, som også selv elsker astronomi? Sæt dagen i den rækkefølge, I synes passer bedst.`,
		hintText: `Her er det en god ide at tale sammen i gruppen og gætte sig frem`,
		popupText: `Dagen følger et naturligt flow, men kan selvfølgelig være forskelligt mellem elever.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Vågne op og spise morgenmad`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Tage bussen eller cykle til skolen`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Starte dagen med en naturvidenskabstime med forsøg`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Hygge med venner i frikvarteret`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Arbejde på et projekt i biologilokalet`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Lave lektier derhjemme`, correctOrderNumbers: [6]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 7, text: `Chille til en nice film om rummet`, correctOrderNumbers: [7]
			})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'fields-paper-doll-chemistry',
		layout: 'fields-chemistry',
		avatarId: 'avatar-3',
		text: `Kemi er et fag, mange synes er spændende. Hvad tror I, man arbejder med i laboratoriet?
			<br />Klik OK, når I synes, I har valgt de rigtige ting.`,
		hintText: `Tænk på ting, man bruger til forsøg – ikke hospitalet.`,
		popupText: `En bunsenbrænder og kitler hører til naturvidenskab på STX, mens ting som stetoskop eller radioaktivt symbol ikke bruges i gymnasiet.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'bunsen', title: 'Bunsenbrænder', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat-grey', title: 'Kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'tube', title: 'Reagensglas', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'dna', title: 'DNA streng', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'syringe', title: 'Sprøjte med nål'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'radioactive', title: 'Radioaktivt logo'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'stethoscope', title: 'Medicinsk stetoskop'
			}),

		]
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-fields-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};